import React from 'react';

import mapModifiers from 'common/utils/functions';

export const iconList = {
  vietnam: 'vietnam',
  english: 'english',
  edit: 'edit',
  filter: 'filter',
  duplicate: 'duplicate',
  next: 'next',
  nextBlue: 'nextBlue',
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile',
  lineup: 'lineup',
  global: 'global',
  pie: 'pie',
  heartbeat: 'heartbeat',
  heartbeatActive: 'heartbeat-active',
  heartbeatIdle: 'heartbeat-idle',
  kidney: 'kidney',
  kidneyActive: 'kidney-active',
  kidneyIdle: 'kidney-idle',
  download: 'download',
  global2: 'global2',
  global2Active: 'global2-active',
  global2Idle: 'global2-idle',
  lineup2: 'lineup2',
  lineup2Active: 'lineup2-active',
  lineup2Idle: 'lineup2-idle',
  pie2: 'pie2',
  pie2Active: 'pie2-active',
  pie2Idle: 'pie2-idle',
  heartbeat2: 'heartbeat2',
};

export type IconName = keyof typeof iconList;

export type IconSize = '12' | '13' | '14' | '16' | '18' | '20' | '22' | '24' | '28' | '30' | '32' | '40' | '48' | '60' | '100' | '120' | '80';

type Props = {
  iconName: IconName;
  size?: IconSize;
};

const Icon: React.FC<Props> = ({ iconName, size }) => (
  <i className={mapModifiers('a-icon', iconName, size)} />
);

Icon.defaultProps = {
  size: '24',
};

export default Icon;
